"use client";

import dynamic from "next/dynamic";
import { useAfterSellerFormReady } from "@/lib/seller-form-ready";

const ThirdPartyTracking = dynamic(
  () => import("./third-party-tracking").then((m) => m.ThirdPartyTracking),
  { ssr: false },
);

export function SiteTracking() {
  return useAfterSellerFormReady() ? <ThirdPartyTracking /> : null;
}
